
import { defineComponent } from 'vue';
import UiModalConfirm from '@/features/redesigned/shared/kit/UiModalConfirm.vue';

export default defineComponent({
  name: 'LogoutConfirm',
  components: { UiModalConfirm },
});
